import type { CourseModule } from "@/core/types";
import { lektionSeriendruckGrundlagen } from "./lektion-01-grundlagen";
import { lektionSeriendruckfelder } from "./lektion-02-felder";
import { lektionSeriendruckRegeln } from "./lektion-03-regeln";
import { lektionEtiketten } from "./lektion-04-etiketten";

/**
 * Die Registerkarte „Sendungen“.
 *
 * Office.js kennt kein MailMerge-Objekt: Hauptdokumenttyp, Datenquelle und
 * Filter liest das Prüfmakro „Seriendruck auslesen“. Die eingefügten
 * Seriendruckfelder sind dagegen gewöhnliche Felder und über WordApi 1.4/1.5
 * prüfbar.
 */
export const modulSeriendruck: CourseModule = {
  id: "seriendruck",
  title: "Seriendruck",
  summary:
    "Serienbriefe, Adressblock und Grußzeile, Regeln, gefilterte Empfänger und " +
    "Etiketten – aus einer Empfängerliste viele persönliche Dokumente.",
  level: "Aufbau",
  lessons: [lektionSeriendruckGrundlagen, lektionSeriendruckfelder, lektionSeriendruckRegeln, lektionEtiketten],
};
